<template>
  <div class="common__pageContainer__3-VhW">
    <div class="common__pageBody__1Dn3a" style="">
      <div class="vipStyle__vip__3yY2f">
        <img src="/static/image/vipBanner.43fe5af505255e4458071fb241bbb46a.png"  class="vipStyle__banner__Is1mD" style="width:100%" />
        <ul>
          <li @click="changvipTab(index+1)" :class="vipTab == (index+1) ? 'vipStyle__active__1bBwm' :''" v-for="(item,index) in 10" :key="index"><img :src="`/static/image/vip${index+1}.png`" style="" /><span>VIP{{index+1}}</span></li>


        </ul>
        <div class="vipStyle__vipInfo__1LJHw" style="display: block" v-if="vipLis.length>0" >
          <img :src="`/static/image/vip${vipTab}.png`" style="" />
          <div>
            <img src="/static/image/i1.307a5200e48ee81639ae8fb5ee655007.png" style="" /><span>累计存款</span>
            <p>{{vipLis[vipTab-1]['recharge']}}</p>
          </div>
          <div>
            <img src="/static/image/i2.6ac37e6878d0b355cd10368d899942c0.png" style="" /><span>累计流水</span>
            <p>{{vipLis[vipTab-1]['flow']}}</p>
          </div>
          <div>
            <img src="/static/image/i3zt.png" style="" />
            <p>VIP{{vipTab}}</p>
          </div>
        </div>

        <div class="vipStyle__table__f94L7" style="margin-top: 0px">
          <h2>VIP最高返水比例</h2>
          <ul>
            <li>VIP等级</li>
            <li>真人(%)</li>
            <li>电子(%)</li>
            <li>棋牌(%)</li>
            <li>体育(%)</li>
            <li>彩票(%)</li>
            <li>电竞(%)</li>

          </ul>

          <ul :class="vipTab == (index+1) ? 'vipStyle__active__1bBwm':''" v-for="(item, index) in vipLis" :key="index" >
            <li>VIP{{index+1}}</li>
            <li>{{ item.realperson }}</li>
            <li>{{ item.electron }}</li>
            <li>{{ item.joker }}</li>
            <li>{{ item.sport }}</li>
            <li>{{ item.lottery }}</li>
            <li>{{ item.e_sport }}</li>
          </ul>

         

        </div>


        <div class="vipStyle__rule__2QNnc" style="padding-top: 50px">
          <h2>活动规则：</h2>
          <p><b>1</b><span>晋升标准：</span>会员的累计存款以及累计流水达到相应级别的要求，即可在次日24点前晋级相应VIP等级。</p>
          <p><b>2</b><span>晋升顺序：</span>VIP等级达到相应的要求可每天晋升一级，但VIP等级不可越级晋升。</p>
          <p><b>3</b><span>保级要求：</span>会员在达到某VIP等级后，90天内投注需要完成保级流水要求。如果在此期间完成晋升，保级要求重新按照当前等级计算。</p>
          <p><b>4</b><span>降级标准：</span>如果会员在一个季度（90天计算）内没有完成相应的保级要求流水，系统会自动降级一个等级，相应的返水及其它优惠也会随之调整至降级后的等级。</p>
          <p><b>5</b><span>升级礼金：</span>升级礼金在会员达到该会员级别后系统自动派发，每个级别的升级礼金每位会员仅能获得1次（升级礼金1倍流水即可提款）。</p>
          <p><b>6</b><span>生日礼金：</span>会员在注册三个月内过生日，今年将不能领取生日礼金。另注册时间大于三个月的会员需在生日当天的VIP页面进行自助领取，每年可领取一次。<br />（生日礼金1倍流水即可提款）。</p>
          <p><b>7</b><span>每月红包：</span>会员在上个月有过至少1次的存款成功记录，即可在次月1号和16号分别前往VIP页面领取当天相应等级的每月红包彩金的1/2（红包礼金1倍流水即可提款）</p>
          <p><b>8</b>{{$store.state.appInfo.title}}娱乐保留对活动的修改，停止及最终解释权。<br />备注：以上为各场馆最高返水，具体返水金额请以实际游戏为准，每日返水将在次日的15:00 - 16:00陆续进行发放。</p>
        </div>
        <div class="msgBox__modal__2kbbd" data-analytics="button" data-label="msg关闭" style="display: none">
          <div class="vipStyle__VipBackDetail__twkAc">
            <header>
              返水规则说明
              <div class="vipStyle__close_icon__34qQ3"></div>
            </header>
            <section>
              <div>
                <div><span style="font-size: 12pt">1.返水优惠发放根据您当天北京时间00:00—23:59之间的有效投注进行计算，数据将与游戏记录中当天数据保持一致；</span></div>
                <div>&nbsp;</div>
                <div><span style="font-size: 12pt">2.根据北京时间您投注的情况，当天玩家所有的投注额返水将在当天结束后24小时内，体育场投注结算后第二天24小时内返水。例如：北京时间11月1日玩家的返水，会在北京时间11月2日15:00-16:00时间段内发放完毕；</span></div>
                <div>&nbsp;</div>
                <div><span style="font-size: 12pt">3.体育中的连串过关投注额返水将计算在注单中最迟开赛的赛事当天中；</span></div>
                <div>&nbsp;</div>
                <div><span style="font-size: 12pt">4.不返水游戏包括</span></div>
                <div><span style="font-size: 12pt">PT电子：丛林巫师、美式轮盘、终极足球、古怪猴子、黄金之旅、高速公路之王、招财进宝；</span></div>
                <div><span style="font-size: 12pt">PP电子：21点富贵临门、百家乐、龙宝百家乐、美式二十一点；</span></div>
                <div>
                  <span style="font-size: 12pt">捕鱼游戏：{{$store.state.appInfo.title}}捕鱼、AG捕鱼、捕鱼3D、捕鱼2D、{{$store.state.appInfo.title}}棋牌中的"海王捕鱼"；<br />彩票游戏：{{$store.state.appInfo.title}}彩票、双赢彩票、TCG彩票；</span>
                </div>
                <div>
                  <span style="font-size: 12pt">棋牌游戏：{{$store.state.appInfo.title}}棋牌中的"龙虎斗"<span style="color: #000000; font-size: 12pt">、博雅棋牌中的"龙虎斗"</span>；<br />泛亚电竞：英雄时时乐、王者时时乐、DOTA英雄乐；</span>
                </div>
                <div><span style="font-size: 12pt">雷火电竞：</span><span style="font-size: 12pt">刀塔宝藏、王者荣耀(夺宝);</span></div>
                <div>&nbsp;</div>
                <div><span style="font-size: 12pt">5.每日返水将不会超过您的返水上限，如您对返水金额有疑问，可联系在线客服为您协助。</span></div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'vip',
  data() {
    return {
      vipLis: [],
      vipTab:1
    };
  },
  created() {
     let that = this;that.uservip();

  },
  methods: {
    changvipTab(val){
      this.vipTab = val;
    },
        	   uservip() {
      let that = this;
      that.$apiFun.post('/api/uservip', {}).then(res => {
  
        if (res.code == 200) {
          that.vipLis = res.data;
                    let num = that.$store.state.userInfo.vip * 1;
          console.log(num);
          $('#n1').html(`<span>￥</span>${that.vipLis[num].flow}`);
          $('#n2').html(`<span>￥</span>${that.vipLis[num].recharge}`);
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '/static/css/VipObPage_8290b769.8d021bde.css';
//@import '/style.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/vip.vue